export const RIGHT_NAV_ALIGN_ITEMS = 'center';
export const BRAND_LOGO_NAME_ID = 'plkLogoTitle';
export const MEDIA_QUERY_HEADER = 'desktop';
